import React from "react";
import {Segment} from "semantic-ui-react";
import {FormattedHTMLMessage as MSGS} from "react-intl";
import {AccountItem} from "../view/CommonPage";
import CardFromToAccount from "./CardFromToAccount";

interface IProperties {
    spoDetails: {
        creditorAccount: AccountItem
        debtorAccount?: AccountItem
        frequency: string
        numberOfPayments: number
        currencyOfTransfer?: string
        firstPayment: ICustomPaymentDetails
        recurringPayment?: ICustomPaymentDetails
        lastPayment?: ICustomPaymentDetails
    }
}

interface ICustomPaymentDetails {
    date: string
    currency: string
    amount: number
    charge?: {
        currency: string
        amount: number
        vatAmount?: number
        chargeBearer: string
        message?: string
    }
}

/**
 * Карточка, отображающая информацию о spo, который проходит авторизацию.
 */
export default class CardSpo extends React.Component<IProperties> {

    render()
    {
        let numberOfPayments;
        if (this.props.spoDetails.numberOfPayments)
        {
            numberOfPayments = <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_number_of_payments"/>} {this.props.spoDetails.numberOfPayments}</div>;
        }
        else 
        {
            numberOfPayments = <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_open_ended"/>}</div>;
        }

        let currencyOfTransfer;
        if (this.props.spoDetails.currencyOfTransfer)
        {
            currencyOfTransfer = <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_currency_of_transfer"/>} {this.props.spoDetails.currencyOfTransfer}</div>;
        }

        let customMessage;
        let firstPaymentChargeDetails;
        if (this.props.spoDetails.firstPayment.charge)
        {
            if (this.props.spoDetails.firstPayment.charge.message)
            {
                customMessage = <Segment><div className={"app-subtext"}><MSGS id={this.props.spoDetails.firstPayment.charge.message}/></div></Segment>
            }

            firstPaymentChargeDetails = this.renderCharge(this.props.spoDetails.firstPayment);
        }

        let firstPayment = new Array<JSX.Element>();
        firstPayment.push(
            <div key={"firstPayment"}>
                <div className={"app-text"}>{<MSGS id="welcome_page_spo_first_payment"/>}</div>
                <Segment>
                    <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_date"/>} {this.props.spoDetails.firstPayment.date}</div>
                    <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_amount"/>} {this.props.spoDetails.firstPayment.amount}</div>
                    <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_currency"/>} {this.props.spoDetails.firstPayment.currency}</div>
                    {firstPaymentChargeDetails}
                </Segment>

            </div>
        )

        let recurringPayment = new Array<JSX.Element>();
        if (this.props.spoDetails.recurringPayment) {
            let chargeDetails = this.renderCharge(this.props.spoDetails.recurringPayment);
            recurringPayment.push(
                <div key={"recurringPayment"}>
                    <div className={"app-text"}>{<MSGS id="welcome_page_spo_recurring_payment"/>}</div>
                    <Segment>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_date"/>} {this.props.spoDetails.recurringPayment.date}</div>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_amount"/>} {this.props.spoDetails.recurringPayment.amount}</div>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_currency"/>} {this.props.spoDetails.recurringPayment.currency}</div>
                        {chargeDetails}
                    </Segment>
                </div>
            )
        }

        let lastPayment = new Array<JSX.Element>();
        if (this.props.spoDetails.lastPayment) {
            let chargeDetails = this.renderCharge(this.props.spoDetails.lastPayment);
            lastPayment.push(
                <div key={"finalPayment"}>
                    <div className={"app-text"}>{<MSGS id="welcome_page_spo_last_payment"/>}</div>
                    <Segment>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_date"/>} {this.props.spoDetails.lastPayment.date}</div>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_amount"/>} {this.props.spoDetails.lastPayment.amount}</div>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_currency"/>} {this.props.spoDetails.lastPayment.currency}</div>
                        {chargeDetails}
                    </Segment>
                </div>
            )
        }

        return (
            <div>
                <div className={"app-text"}><MSGS id="welcome_page_spo_payment_consent_first_line"/></div>
                <Segment >
                    <Segment>
                        <div className={"app-subtext"}> {<MSGS id="welcome_page_spo_frequency"/>} {this.props.spoDetails.frequency}</div>
                        {numberOfPayments}
                        {currencyOfTransfer}
                        <CardFromToAccount debtorAccount={this.props.spoDetails.debtorAccount} creditorAccount={this.props.spoDetails.creditorAccount}/>
                    </Segment>
                    <Segment>
                        {firstPayment}
                        {recurringPayment}
                        {lastPayment}
                    </Segment>
                    {customMessage}
                </Segment>
            </div>
        )
    }

    renderCharge(payment: ICustomPaymentDetails): JSX.Element | null {
        const charge = payment.charge;
        if (!charge || !charge.amount)
            return null;

        const bearerMap: Record<string, string> = {
            DEBT: 'welcome_page_payment_consent_charge_bearer_our',
            CRED: 'welcome_page_payment_consent_charge_bearer_ben'
        };
        const chargeBearerText = bearerMap[charge.chargeBearer] || 'welcome_page_payment_consent_charge_bearer_sha';
        const vatSegment = charge.vatAmount ? (
            <div className="app-subtext">
                <MSGS id="welcome_page_consent_vat_amount" /> {charge.vatAmount} {charge.currency}
            </div>
        ) : null;

        return (
            <Segment>
                <div className={"app-subtext"}> {<MSGS id="welcome_page_payment_consent_charges"/>}</div>
                <div className="app-subtext"><MSGS id="welcome_page_consent_charge_amount" /> {charge.amount} {charge.currency}</div>
                {vatSegment}
                <div className="app-subtext"><MSGS id={chargeBearerText} /></div>
            </Segment>
        );
    }
}

